import { farmStore, syncQueue } from '../../offline/indexedDBService'
import { v4 as uuidv4 } from 'uuid'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getFarms = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({ type: 'FARM_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/farm/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'FARM_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'FARM_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'FARM_NOT_LOADING' })
    }
}

export const getForSelect = () => async (dispatch) => {
    dispatch({ type: 'FARM_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/farm/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'FARM_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'FARM_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'FARM_NOT_LOADING' })
    }
}

export const getFarm = (farm) => async (dispatch) => {
    dispatch({ type: 'FARM_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/farm/get/' + farm, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'FARM_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'FARM_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'FARM_NOT_LOADING' })
    }
}

export const addFarm = (farmdata) => async (dispatch, getState) => {
	const tempId = uuidv4()
	const { breeders, technicians } = getState().users

	if (!navigator.onLine) {
		await farmStore.setItem(tempId, farmdata)
		await syncQueue.setItem(tempId, {
			type: 'FARM_ADD_OFFLINE',
			payload: farmdata
		})

		const breederObj =
			breeders.find(b => b._id === farmdata.breeder) || {
				_id: farmdata.breeder,
				name: farmdata.breeder
			}

		const technicianObjs = (farmdata.technicians || []).map(tid =>
			technicians.find(t => t._id === tid) || {
				_id: tid,
				name: tid
			}
		)

		dispatch({
			type: 'FARM_ADD_SUCCESS',
			payload: {
				farm: {
					...farmdata,
					_id: tempId,
					id: tempId,
					offline: true,
					breeder: breederObj,
					technicians: technicianObjs
				},
				message: 'success'
			}
		})
		return
	}

	// Parte online
	try {
		const { data, status } = await Axios.post('/api/farm/register', farmdata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200) {
			dispatch({ type: 'FARM_ADD_SUCCESS', payload: data })
		} else if (status === 264 || status === 260) {
			dispatch({ type: 'FARM_WRONG_SUCCESS', payload: data })
		} else {
			dispatch({ type: 'FARM_NOT_LOADING' })
		}
	} catch (error) {
		dispatch({ type: 'FARM_NOT_LOADING' })
	}
}

export const editFarm = (farmdata, farmId) => async (dispatch, getState) => {
	const { breeders, technicians } = getState().users

	if (!navigator.onLine) {
		await farmStore.setItem(farmId, farmdata)
		await syncQueue.setItem(farmId, {
			type: 'FARM_EDIT_OFFLINE',
			payload: farmdata
		})

		const breederObj =
			breeders.find(b => b._id === farmdata.breeder) || {
				_id: farmdata.breeder._id,
				name: farmdata.breeder.name
			}

		const technicianObjs = (farmdata.technicians || []).map(tid =>
			technicians.find(t => t._id === tid) || { _id: tid, name: tid }
		).map(t => ({ _id: t._id, name: t.name }))

		dispatch({
			type: 'FARM_EDIT_SUCCESS',
			payload: {
				farm: {
					...farmdata,
					_id: farmId,
					offline: true,
					breeder: breederObj,
					technicians: technicianObjs
				},
				message: 'editSuccess'
			}
		})
		return
	}

	try {
		const { data, status } = await Axios.put('/api/farm/edit/' + farmId, farmdata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200 || status === 264) {
			dispatch({ type: 'FARM_EDIT_SUCCESS', payload: data })
		}
	} catch (error) {
		dispatch({ type: 'FARM_NOT_LOADING' })
	}
}
